export default {
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  localMode: import.meta.env.MODE === 'localdev',
};
